var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.055c0 .69-.56 1.25-1.25 1.25H12.5v3.194a1.25 1.25 0 01-2.5 0v-3.194H1.25A1.252 1.252 0 01.12 11.52l5-10.555a1.25 1.25 0 012.26 1.071l-4.155 8.769H10V5.25a1.25 1.25 0 012.5 0v5.555h1.25c.691 0 1.25.562 1.25 1.25z",
    fill: "#00B9EF"
  })));
}

export default SvgFour;